<template>
  <div class="layout"
       @mouseover="visibleHandler(true)">
<!--      <ul class="menu"-->
<!--        @mouseout="visibleHandler(false)"-->
<!--        v-show="visible">-->
<!--      <li>帐号：<span class="name">李四</span></li>-->
<!--      <li>会员将于<span class="tip">2023-12-12</span>日过期</li>-->
<!--      <li><span class="icon icon-keep"></span>收藏夹</li>-->
<!--      <li>-->
<!--        <el-icon class="lock"><Lock /></el-icon>-->
<!--        <span class="tip">修改密码</span>-->
<!--      </li>-->
<!--    </ul>-->
    <span>{{ userName }}</span>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {Lock} from "@element-plus/icons-vue";

const props = defineProps({
  userName: String
})

const visible = ref(false);
const visibleHandler = (v) => visible.value = v;
</script>

<style scoped>
.layout{
  position: relative;
  cursor: pointer;
}

.menu{
  position: absolute;
  width: 220px;
  padding: 10px 0;
  color: #555;
  left: -90px;
  top: 30px;
  border-radius: 8px;
  font-size: 14px;
  z-index: 100;
  background: #fff url("../../assets/images/h_bg1.png") repeat-x;
}

.menu li{
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.menu li:hover{
  background-color: #d6f7fe;
}

.tip{
  color: #005aff;
}

.name{
  font-weight: 500;
}

.icon{
  display: inline-block;
  width: 16px;
  height: 16px;
}

.icon-keep{
  background: url("../../assets/images/collect.png") no-repeat;
  background-size: cover;
  margin-right: 8px;
}

.lock{
  position: relative;
  top: 3px;
  font-size: 18px;
  margin-right: 10px;
  color: #e8e8e8;
}
</style>